export const PATH_INDEX = '/';

export const PATH_SERVER_ERROR = '/500';

export const PATH_VAULTS_V2 = '/vaultsV2';

export const PATH_VAULTS = '/vaults';

export const PATH_VAULT = `${PATH_VAULTS}/:id`;

export const PATH_SIMILAR_VAULTS = '/similar-vaults';

export const PATH_CREATE_VAULT = '/create-vault';

export const PATH_EDIT_VAULT = '/edit-vault/:id';

export const PATH_DEX_ETF = '/dexETF';

export const PATH_DEX_ETF_FOUNDS = `${PATH_DEX_ETF}/:address`;

export const PATH_DEX_SWAP = '/swap';

export const PATH_DEX_LIQUIDITY = '/liquidity';

export const PATH_DEX_LIQUIDITY_ADD = '/add/*';

export const PATH_DEX_ADD = '/add';

export const PATH_DEX_POOL_FIND = '/find';

export const PATH_DEX_DAO = '/dexDAO';

export const PATH_USDEX = '/usdex';

export const PATH_GDEX = '/gDex';

export const PATH_PERPETUALS = '/perpetuals';

export const PATH_TERMS_AND_CONDITIONS = '/terms-and-conditions';

export const PATH_LEADERBOARD = '/leaderboard';

export const PATH_REQUEST_FARM = '/request-farm';

export const PATH_BRIDGE = '/bridge';

export const PATH_DOCUMENTATION = 'https://docs.dexfi.com';

export const PATH_DEXVAULTS_DOCS = `${PATH_DOCUMENTATION}/dexvaults/overview`;

export const PATH_EDUCATION = `${PATH_DOCUMENTATION}/dexed/education`;

export const PATH_TEAM = `${PATH_DOCUMENTATION}/team-and-kyc`;

export const PATH_CONTACT = `${PATH_DOCUMENTATION}/links-and-socials`;

export const PATH_DEXDAO_DOCS = `${PATH_DOCUMENTATION}/dexdao/gdex-dexfi-governance`;

export const PATH_USDEX_DOCS = `${PATH_DOCUMENTATION}/usdex+/overview`;

export const PATH_DOCS = 'https://dex-finance.gitbook.io/dex-finance-docs/';

export const PATH_LEGACY_DEXFINANCE = 'http://legacy.dexfinance.com/';

export const PATH_DEXSWAP_DOCUMENTATION = `${PATH_DOCUMENTATION}/dexfi-products/dexswap`;

export const PATH_DEXFI_AI = 'https://dexfi.ai/';
